/* eslint-disable max-depth */
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import AppAcquisitionOverlay from "web/react/components/app-acquisition-overlay/app-acquisition-overlay";
import EmailCaptureOverlay from "web/react/components/email-capture-overlay/email-capture-overlay";
import withReduxProvider from "web/react/redux-provider";
import browser from "web/script/utils/browser";

function mapStateToProps(state) {
    const { captureType, open } = state.customerCaptureOverlayReducer;
    return {
        captureType,
        overlayOpen: open,
    };
}

const captureTypesForAcquisition = new Set(["signup_du", "signup_feed_save"]);

export function CustomerCaptureOverlay({ appAcquisition, ...props }) {
    const { overlayOpen, captureType } = props;
    if (!overlayOpen) {
        return null;
    }

    const showAppAcquisition =
        appAcquisition && browser.ios && captureTypesForAcquisition.has(captureType); // TODO:  .co.uk...
    // is it ios and in an a/b test, and captureType is one of sfl and designer updates.
    return (
        <>
            {showAppAcquisition ? (
                <AppAcquisitionOverlay captureType={captureType} />
            ) : (
                <EmailCaptureOverlay {...props} />
            )}
        </>
    );
}
export default withReduxProvider(connect(mapStateToProps)(CustomerCaptureOverlay));
CustomerCaptureOverlay.propTypes = {
    appAcquisition: PropTypes.bool,
    captureType: PropTypes.oneOf([
        "signup_lead_save",
        "signup_pdp_save",
        "signup_feed_save",
        "signup_du",
        "signup_search",
        "stock_alert",
        "stock_alert_lead_return",
        "signup_oos_save",
        "ta_collection",
    ]),
    overlayOpen: PropTypes.bool,
};
